import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import { Socket } from "socket.io-client";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import SupplierContext from "../../../contexts/SupplierContext";
import UserContext from "../../../contexts/UserContext";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwButton from "../../shared/OwButton/OwButton";
import OwTable from "../../shared/OwTable/OwTable";
import PaginationBar from "../../shared/PaginationBar/PaginationBar";
import IWarehouse from "../../../models/IWarehouse";
import IOwTableCols from "../../../models/IOwTableCols";
import IWarehouse_Transfer from "../../../models/IWarehouse_Transfer";
import { OwIconButton } from "../../shared/OwIconButton/OwIconButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IGetWarehouseTransfersDTO from "../../../models/DTO/IGetWarehouseTransfersDTO";
import IOnGetWarehouseTransfersDTO from "../../../models/DTO/IOnGetWarehouseTransfersDTO";
import IOnGetWarehousesDTO from "../../../models/DTO/IOnGetWarehousesDTO";
import IGetWarehousesDTO from "../../../models/DTO/IGetWarehousesDTO";
import { TransfersSidebar } from "../TransfersSidebar/TransfersSidebar";
import { useNavigate } from "react-router-dom";
import IProcessWarehouseTransferDTO from "../../../models/DTO/IProcessWarehouseTransferDTO";
import IOnProcessWarehouseTransferDTO from "../../../models/DTO/IOnProcessWarehouseTransferDTO";
import INotification from "../../../models/INotification";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import UserService from "../../../services/UserService";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import {SocketContext} from "../../../contexts/SocketContext";
import UiContext from "../../../contexts/UiContext";

type Props = {};

export const Transfers = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);
    const history = useNavigate();
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const getBreadcrumbs = () => {
        return [
            {
                title: "dashboard",
                url: "/dashboard",
            },
            {
                title: "inventory",
                url: "/inventory",
            },
            {
                title: "warehouses",
                url: "/inventory/transfers",
            },
        ];
    };

    const [isDataFetching, setIsDataFetching] = useState(true);
    const [isInitialData, setIsInitialData] = useState(true);
    const [pagination, setPagination] = useState({ offset: 0, limit: 100 });
    const [transfers, setTransfers] = useState<IWarehouse_Transfer[]>([]);
    const [totalTransfers, setTotalTransfers] = useState(0);
    const [warehouses, setWarehouses] = useState<IWarehouse[]>([]);
    const [crumbs, setCrumbs] = useState<IBreadcrumbs[]>(getBreadcrumbs());
    const [hideReceivedBy, setHideReceivedBy] = useState(true);

    const processWarehouseTransfer = () => {};

    const onProcessWarehouseTransfer = () => {
        const notification: INotification = {
            message: "successfully_processed_warehouse_transfer",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        uiContext.notifyFn(null, notification);

        getTransfers();
    };

    const getTransfers = () => {
        const payload: IGetWarehouseTransfersDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            limit: 25,
            offset: 0,
        };

        if (hideReceivedBy) {
            payload.hideReceived = hideReceivedBy;
        }

        socket.emit(EndpointsEnum.WarehouseGetTransfers, payload);

        setIsDataFetching(true);
    };

    const onGetTransfers = (data: IOnGetWarehouseTransfersDTO) => {
        setTransfers(data.warehouseTransfers);
        setTotalTransfers(data.total);

        setIsDataFetching(false);
        setIsInitialData(false);
    };

    const getWarehouses = () => {
        const data: IGetWarehousesDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        socket.emit(EndpointsEnum.WarehouseGetWarehouses, data);
    };

    const onGetWarehouses = (data: IOnGetWarehousesDTO) => {
        setWarehouses(data.warehouses);
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.WarehouseOnProcessWarehouseTransfer, fn: onProcessWarehouseTransfer },
        { endpoint: EndpointsEnum.WarehouseOnGetTransfers, fn: onGetTransfers },
        { endpoint: EndpointsEnum.WarehouseOnGetWarehouses, fn: onGetWarehouses },
    ];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        getWarehouses();
        getTransfers();

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const viewTransfer = (row: IWarehouse_Transfer) => {
        history(`/inventory/transfers/${row.guid}`);
    };

    const renderActionsColFn = (row: IWarehouse_Transfer) => {
        return (
            <div className={"d-flex"}>
                {row.received_at ? null : (
                    <div>
                        <OwIconButton
                            iconClass={"fas fa-trash-alt me-2"}
                            iconColorClass={"text-danger"}
                            fn={() => deleteWarehouseTransfer(row)}
                        />
                        {/*<OwIconButton*/}
                        {/*    iconClass={"fas fa-pencil-alt me-2"}*/}
                        {/*    iconColorClass={"text-primary"}*/}
                        {/*    fn={() => openWarehouseTransferSidebar(row)}*/}
                        {/*/>*/}
                    </div>
                )}

                <div className={"ms-auto"}>
                    <OwLabel title={"view"} fn={() => viewTransfer(row)} />
                </div>
            </div>
        );
    };

    const renderNameColFn = (row: IWarehouse_Transfer) => {
        return (
            <div>
                {row.Origin_Warehouse?.name} <i className={"fas fa-arrow-right"} /> {row.Destination_Warehouse?.name}
            </div>
        );
    };

    const renderActionButtonsColFn = (row: IWarehouse_Transfer) => {
        return (
            <div className={"d-flex"}>
                <div>
                    <OwButton
                        title={"transfer_slip"}
                        fn={() => {
                            viewTransferSlip(row);
                        }}
                    />
                </div>
                {row.received_at ? (
                    <div className={"ms-4"}>
                        <OwLabel title={"received_by"} /> {row.Received_By?.name} <OwLabel title={"at"} />{" "}
                        {UserService.parseDate(row.received_at)}
                    </div>
                ) : (
                    <div className={"ms-5"}>
                        <OwButton
                            title={"receive_transfer"}
                            fn={() => {
                                receiveTransfer(row);
                            }}
                        />
                    </div>
                )}
            </div>
        );
    };

    const viewTransferSlip = (row: IWarehouse_Transfer) => {
        history(`/inventory/transfers/${row.guid}/slip`);
    };

    const receiveTransfer = (row: IWarehouse_Transfer) => {
        history(`/inventory/transfers/${row.guid}/received`);
    };

    const divColumns = [
        {
            title: "",
            renderFn: renderNameColFn,
        },
    ];

    const columns: IOwTableCols[] = [
        {
            isActionsCol: true,
            title: "",
            valueProp: "",
            renderFn: renderActionsColFn,
            renderFnEmitsRow: true,
        },
        {
            title: "name",
            valueProp: "",
            renderFn: renderNameColFn,
            renderFnEmitsRow: true,
        },
        {
            title: "",
            valueProp: "",
            renderFn: renderActionButtonsColFn,
            renderFnEmitsRow: true,
        },
    ];

    const deleteWarehouseTransfer = (transfer: IWarehouse_Transfer) => {
        const payload: IProcessWarehouseTransferDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            warehouseTransferId: transfer.id,
            deleteFlag: true,
        };

        socket.emit(EndpointsEnum.WarehouseProcessWarehouseTransfer, payload);
    };

    const openWarehouseTransferSidebar = (transfer?: IWarehouse_Transfer) => {
        const sideBarComponent = (
            <TransfersSidebar cancelFn={cancelSidebarFn} notifyFn={uiContext.notifyFn} socket={socket} warehouses={warehouses} />
        );

        uiContext.setSidebarComponent(sideBarComponent);
        uiContext.toggleSidebar(true);
    };

    const cancelSidebarFn = (refresh?: boolean) => {
        uiContext.toggleSidebar(false);
        uiContext.setSidebarComponent(null);

        if (refresh) {
            getTransfers();
        }
    };

    const paginationChanged = (offset: number, limit: number) => {
        setPagination({ offset, limit });
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        switch (name) {
            case "hide_received_by":
                setHideReceivedBy(value);
                break;
        }
    };

    return (
        <div className={"Transfers"}>
            <Breadcrumbs crumbs={crumbs} />

            <div className="row mt-2">
                <div className={"col-12 d-flex align-items-center"}>
                    <OwTitle title={"transfers"} leftIconName={"fad fa-dolly"} />
                    <div>
                        <OwButton
                            className={"ms-2 btn-warning"}
                            title={"create"}
                            leftIconClass={"fas fa-plus"}
                            fn={() => {
                                openWarehouseTransferSidebar();
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className="row mt-3">
                <div className="col-12">
                    <OwCheckbox
                        fn={handleChange}
                        name={"hide_received_by"}
                        truthyVal={true}
                        falsyVal={false}
                        checked={hideReceivedBy}
                        label={"hide_received"}
                    />

                    <div>
                        <OwButton title={"search"} fn={getTransfers} />
                    </div>
                </div>
            </div>

            <div className="row mt-3">
                <div className="col-12">
                    <OwTable
                        columns={columns}
                        dataSet={transfers}
                        userModel={userModel}
                        supplierModel={supplierModel}
                        dataFetch={isDataFetching}
                        initialData={isInitialData}
                        tableConfig={{ tableStriped: true, hasDetailView: false }}
                    />
                </div>
            </div>

            <div className={"row"}>
                <div className={"col-12"}>
                    <PaginationBar
                        offset={pagination.offset}
                        limit={pagination.limit}
                        totalRecords={totalTransfers}
                        onPaginationChanged={paginationChanged}
                    />
                </div>
            </div>
        </div>
    );
};
